
// Use this token to work locally.
// You can get it from any request that is sent from the UI to the API in DEV environment.
// IMPORTANT: ALWAYS UPLOAD TO THE REPO AS 'undefined'.
export const localToken = undefined;

// IMPORTANT: ALWAYS UPLOAD TO THE REPO AS 'undefined'.
export const useMockUser = undefined;

export default window.environmentConfig;